interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionTitle({ eyebrow, title, desc, align = 'left' }: SectionTitleProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'text-left max-w-3xl'}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-primary-700">
          <span className="w-6 h-px bg-primary-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">{title}</h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}